import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: ${spacing.space4};
  margin-bottom: ${spacing.space8};

  @media (min-width: ${breakpoints.l}) {
    margin-top: -${spacing.space16};
    gap: ${spacing.space8};
  }
`;

export const ChipWrapper = styled.span`
  display: inline-flex;
`;
